import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import moment from 'moment';

import { generateSecretChatId } from '../utils/generateSecretChatId';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { initialChat } from '../constants/initialStates';

export const createSecretChat = createAsyncThunk(
  'messenger/createSecretChat',
  async (data, { signal, rejectWithValue }) => {
    try {
      const source = axios.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });

      try {
        // TODO: replace with api call (return updated conversation list)

        return Promise.resolve({
          ...initialChat,
          timestamp: moment().toISOString(),
          chatId: generateSecretChatId(data.chatId),
          isSecret: true,
        });
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const createSecretChatExtraReducers = {
  [createSecretChat.pending]: (state, action) => {
    checkAndSetLoadingWithId(
      state.createSecretChat.request,
      action,
      action.meta.arg.chatId,
    );
  },
  [createSecretChat.fulfilled]: (state, action) => {
    onMatchedRequest(
      state.createSecretChat.request[action.meta.arg.chatId],
      action,
      () => {
        const conversations =
          state.conversations?.[action.meta.arg.channelUID] || [];

        if (conversations.includes(action.payload.chatId)) return;

        state.conversations = {
          ...state.conversations,
          [action.meta.arg.channelUID]: [
            action.payload.chatId,
            ...conversations,
          ],
        };

        state.chats.byId[action.payload.chatId] = action.payload;
        state.chats.allIds.push(action.payload.chatId);
        state.messages.byChatId = {
          ...state.chats.byChatId,
          [action.payload.chatId]: [],
        };
      },
    );
  },
  [createSecretChat.rejected]: (state, action) => {
    handleRequestRejection(
      state.createSecretChat.request[action.meta.arg.chatId],
      action,
    );
  },
};
